import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ai-chatbot-message-feedback',
  templateUrl: './ai-chatbot-message-feedback.component.html',
  styleUrls: ['./ai-chatbot-message-feedback.component.scss'],
  standalone: false,
})
export class AiChatbotMessageFeedbackComponent {
  @Input() messageId: string;

  @Output() thumbsUpClicked = new EventEmitter<boolean>();
  @Output() feedbackSent = new EventEmitter<string>();

  showFeedbackForm: boolean = false;
  feedbackText: string = '';
  feedbackSentState: boolean = false;
  thumbsUpActive: boolean = false;

  onThumbsDownClick(): void {
    this.thumbsUpActive = false;
    this.showFeedbackForm = !this.showFeedbackForm;
    if (!this.showFeedbackForm) {
      this.feedbackText = '';
      this.feedbackSentState = false;
    }
  }

  onThumbsUpClick(): void {
    // Close feedback form if open
    if (this.showFeedbackForm) {
      this.showFeedbackForm = false;
      this.feedbackText = '';
      this.feedbackSentState = false;
    }
    // Toggle thumbs up active state
    this.thumbsUpActive = !this.thumbsUpActive;
    // Only emit the new state (true = activated, false = deactivated)
    this.thumbsUpClicked.emit(this.thumbsUpActive);
  }

  closeFeedbackForm(): void {
    this.showFeedbackForm = false;
    this.feedbackText = '';
    this.feedbackSentState = false;
  }

  sendFeedback(): void {
    if (!this.feedbackText.trim()) {
      return;
    }

    // Emit feedback to parent component
    this.feedbackSent.emit(this.feedbackText);

    // Show success message
    this.feedbackSentState = true;
    this.feedbackText = '';
  }
}
